import BaseIconSvg from '@/components/bases/BaseIconSvg';
import dayjs from 'dayjs';
import React from 'react';

interface Props {
  user?: Record<string, any>;
  emrConfig?: Record<string, any>;
  data: Record<string, any>;
  navigate: (path: string, options?: Record<string, any>) => void;
  show: string;
  config: Record<string, any>;
  sameDay: boolean;
}

const SurvivalIndexItem = ({ user, emrConfig, data, navigate, show, config, sameDay }: Props) => {
  return (
    <div className="bg-gray-1 shadow-md mx-6 mb-4 rounded-lg">
      <div
        className="p-4 flex flex-row"
        onClick={() =>
          navigate(`/phr-mobile/records-by-type/${user?._id}`, {
            state: {
              emrTypeCode: emrConfig?.code,
              emrDate: data?.date,
              uid: user?._id,
              title: emrConfig?.name,
            },
          })
        }
      >
        <BaseIconSvg src={config?.icon} className="wh-[56px]" />
        <div className="ml-4 flex flex-col flex-1">
          <div className="flex flex-row justify-between">
            <span className="cms-h4">{config?.label || emrConfig?.name}</span>
            <span className="cms-body2">{dayjs(data?.date).format('DD/MM/YYYY')}</span>
          </div>
          <div className="p-2 bg-gray-2 rounded-lg mt-1">
            {show ? (
              <div
                className="flex flex-row justify-start my-1 items-center"
                dangerouslySetInnerHTML={{ __html: show }}
              ></div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      {!sameDay && config?.btnUpdate && (
        <div className="border-t border-gray-4 p-4 flex flex-row items-center justify-between">
          <span className="cms-body1 text-violet-14">Hôm nay bạn chưa đo</span>
          <button
            className="cms-h5 text-orange-8 bg-gray-2 border-orange-8 py-2 rounded-full px-6 border"
            onClick={() =>
              navigate(`/phr-mobile/logs/${user?._id}`, {
                state: { user, uid: user?._id, emrType: config.emrTypeOpen, title: emrConfig?.name },
              })
            }
          >
            <span>Đo ngay</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default SurvivalIndexItem;
